import { styled } from "@mui/material";
import { useState } from "react";
import { Button, Checkbox } from "@kaltura/ds-react-components";
import { FormLabel } from "@kaltura/mediaspace-shared-ui/form";
import { translate } from "@kaltura/mediaspace-shared-utils";

export interface CreationToolWrapperActionsProps {
    formId: string;
    saveButtonLabel: string;
    onBack: () => void;
    onCancel: () => void;
    onSubmit: () => void;
    showActionButtons: boolean;
    hasEntry: boolean;
    readyForPublish: boolean;
    finishedUploading: boolean;
    editFormShown: boolean;
    touLink?: string;
    processing?: boolean;
}

const StyledActions = styled("div")(({ theme }) => ({
    display: "flex",
    justifyContent: "space-between",
    alignItems: "flex-end",
}));

const StyledTOUContainer = styled("div")(({ theme }) => ({
    display: "flex",
    gap: theme.spacing(1),
    paddingTop: theme.spacing(1),
}));

const StyledActionButtons = styled("div")(({ theme }) => ({
    display: "flex",
    gap: theme.spacing(1),
}));

/**
 * actions bar for Add Content creation tool wrapper
 */
export const CreationToolWrapperActions = ({
    formId,
    saveButtonLabel,
    onSubmit,
    onBack,
    onCancel,
    showActionButtons,
    hasEntry,
    readyForPublish,
    finishedUploading,
    editFormShown,
    touLink,
    processing = false,
}: CreationToolWrapperActionsProps) => {
    const [touApproved, setTouApproved] = useState(!touLink);

    return (
        <StyledActions>
            <StyledActionButtons>
                <Button onClick={onBack} variant={"borderless"} color={"secondary"} disabled={processing}>
                    {translate("Back")}
                </Button>

                {showActionButtons && touLink && (
                    <StyledTOUContainer>
                        <Checkbox
                            id={"touCheckbox"}
                            value={"nothing"}
                            disabled={!readyForPublish}
                            onChange={(event) => {
                                setTouApproved(event.currentTarget.checked);
                            }}
                        />
                        <FormLabel
                            htmlFor={"touCheckbox"}
                            text={translate(
                                "I accept the %1Terms of Use%2",
                                [`<a href="${touLink}" target="blank">`, "</a>"]
                            )}
                            id={"touCheckbox-label"}
                        />
                    </StyledTOUContainer>
                )}
            </StyledActionButtons>

            <StyledActionButtons>
                <Button variant={"borderless"} color={"secondary"} onClick={onCancel} disabled={processing}>
                    {translate("Cancel")}
                </Button>

                {showActionButtons && (
                    <Button
                        type="submit"
                        form={formId}
                        disabled={
                            !readyForPublish
                            || !hasEntry
                            || (!editFormShown && !finishedUploading)
                            || !touApproved
                            || processing
                        }
                        loading={processing}
                        onClick={onSubmit}
                    >
                        {saveButtonLabel}
                    </Button>
                )}
            </StyledActionButtons>
        </StyledActions>
    );
};
